export default __webpack_public_path__ + "static/media/18.5ba9c6c3.png";